import { FormFieldState } from '../types';

export type FiberWaitListState = {
  firstName: FormFieldState<string>;
  lastName: FormFieldState<string>;
  email: FormFieldState<string>;
  phone: FormFieldState<string>;
  isWaitlistLoading: boolean;
  isWaitlistRequestComplete: boolean;
};

export const initialFiberWaitListState: FiberWaitListState = {
  firstName: { value: '', valid: null, hintText: 'First name is required' },
  lastName: { value: '', valid: null, hintText: 'Last name is required' },
  email: { value: '', valid: null, hintText: 'Email is required' },
  phone: { value: '', valid: null, hintText: 'Phone number format invalid' },
  isWaitlistLoading: false,
  isWaitlistRequestComplete: false,
};

export type FiberWaitlistInformation = {
  firstName: FormFieldState<string>;
  lastName: FormFieldState<string>;
  email: FormFieldState<string>;
  phone: FormFieldState<string>;
};
